import React, { useState } from "react";

import {
  ProvincesApi,
  SUCCESS_API_RESPONSE,
} from "../../../Shared/Constants/api";
import {
  errorDeleteingData,
  errorGettingData,
  errorInsertingData,
  errorUpdatingData,
  genericError,
  ItemCreated,
  ItemUpdated,
  successDeleted,
} from "../../../Shared/Constants";
import { alertToastErrorFromResponse } from "../../../Shared/Utils/errorUtils";
import { alertError, alertSuccess } from "../../../Shared/Utils/alertMessages";
import { getCall } from "../../../Shared/Api/GetApi";
import { putCall } from "../../../Shared/Api/PutApi";
import { deleteCall } from "../../../Shared/Api/DeleteApi";

import { postCall } from "../../../Shared/Api/PostApi";
import Context from "./Index";
import {
  provinceCreationPayload,
  provinceUpdatePayload,
} from "../Data/ProvinceWrappers";

export default function ProvinceProvider(props) {
  const [showModal, setShowModal] = useState(false);
  const [readOnly, setReadOnly] = useState(false);

  const modalTogle = () => {
    setShowModal(!showModal);
  };

  const [items, setItems] = useState([]);
  const [item, setItem] = useState();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  /**
   * Get a list of items
   * @param {*} page
   * @param {*} limit
   */
  const fetchItems = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getCall(ProvincesApi, {
        page: page,
        limit: limit,
        ...filters,
      });
      let data = response.data;
      if (response.result === SUCCESS_API_RESPONSE) {
        setItems(data?.items);
        setTotalRows(items.length + data.items.length);
      } else {
        setTotalRows(0);
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Get one note data
   * @param {*} id
   */
  const getItem = async (id) => {
    setLoading(true);
    try {
      let response = await getCall(`${ProvincesApi}/${id}`);
      let data = response.data;
      if (response.result === SUCCESS_API_RESPONSE) {
        setItem(data);
      } else {
        setItem({});
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Create a item
   * @param {*} data
   */
  const createItem = async (data) => {
    setSaving(true);
    try {
      let response = await postCall(
        ProvincesApi,
        provinceCreationPayload(data)
      );

      if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
        setItems([]);
        setCurrentPage(1);
        fetchItems(currentPage, rowsPerPage);
        alertSuccess(ItemCreated);
        modalTogle();
      } else {
        alertToastErrorFromResponse(errorInsertingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  /**
   * Update a item
   * @param {*} data
   * @param {*} id
   */
  const updateItem = async (data, id) => {
    setSaving(true);
    try {
      let response = await putCall(
        `${ProvincesApi}/${id}`,
        provinceUpdatePayload(data)
      );

      if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
        alertSuccess(ItemUpdated);
        fetchItems(currentPage, rowsPerPage);
        modalTogle();
      } else {
        alertToastErrorFromResponse(errorUpdatingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  /**
   * Delte a item
   * @param {*} id
   */
  const deleteItem = async (id) => {
    setSaving(true);
    try {
      let response = await deleteCall(`${ProvincesApi}/${id}`, id);

      if (response?.result && response?.result == SUCCESS_API_RESPONSE) {
        const newdata = items.filter((elem) => {
          return id !== elem.id;
        });
        setItems(newdata);
        alertSuccess(successDeleted);
      } else {
        alertToastErrorFromResponse(errorDeleteingData, response);
      }
    } catch (error) {
      alertError(genericError + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Context.Provider
      value={{
        ...props,
        fetchItems,
        items,
        rowsPerPage,
        currentPage,
        setCurrentPage,
        createItem,
        updateItem,
        deleteItem,
        item,
        setItem,
        loading,
        saving,
        showModal,
        modalTogle,
        setShowModal,
        setFilters,
        filters,
        setItems,
        totalRows,
        readOnly,
        setReadOnly,
        getItem,
        searchTerm,
        setSearchTerm,
      }}
    >
      {props.children}
    </Context.Provider>
  );
}
